import MessagingLogPage from '../agency/MessagingLog';

export default function AdminMessagingLog() {
  return <MessagingLogPage />;
}
